import React from "react";
import { Grid } from "@sumprio/ui";
import type { EmptyStateProps } from "./types";
import EmptyStateIconSlot from "./EmptyStateIconSlot";
import EmptyStateContent from "./EmptyStateContent";
import EmptyStateAction from "./EmptyStateAction";

export default function EmptyState({
  title,
  description,
  actionLabel,
  onAction,
  icon,
  actionIcon = undefined,
}: EmptyStateProps) {
  return (
    <Grid
      role="status"
      aria-label={title}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      padding="xl"
      gap="md"
      width="100%"
    >
      <EmptyStateIconSlot icon={icon} />
      <EmptyStateContent title={title} description={description} />
      <EmptyStateAction actionLabel={actionLabel} onAction={onAction} actionIcon={actionIcon} />
    </Grid>
  );
}
